import { render } from "./Profile.tab.vue?vue&type=template&id=7bfd8020"
import script from "./Profile.tab.vue?vue&type=script&lang=js"
export * from "./Profile.tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__